import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../../common/components";
import './filter-options-text.scss';
import * as Yup from "yup";

const CityFilter: any = (
  props: any
) => {
  const { city, handleCityChange, isCityEnabled, cityError } = props
  useEffect(() => {
    if (!isCityEnabled) {
      handleCityChange({ target: { value: "", name: "city" } } as any, "city");
    }
  }, [isCityEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          city: city,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="city"
            placeholder="Enter City"
            optional={false}
            disabled={false}
            value={city}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleCityChange(e, "city")
            }
          />
          {cityError && <div className="error-text">{cityError}</div>}
        </Form>
      </Formik>
    </div>

  );
};
export default CityFilter;